export const EXTRA_DATA_STATE = {
    "UNTOUCHED": "untouched",
    "CORRECT": "correct",
    "WRONG": "wrong",
    "EMPTY": "empty"
}